export const css = {
    container: 'Fcg-Yf-q',
    toolsContainer: 'gkTUYXup',
    tools: '_9vfL5Nxt',
    toolsList: 'F0w0U--7',
    breadCrumbs: 'WCjNhHSG',
    breadcrumbItems: 'yobl-GR9',
    home: '_2CkSjPEP',
    last: 'x9FuHC5I',
    quizButton: 'etZdk6bC',
    layout: 'P7Ps-OP-',
    content: 'PT9hwtOW',
    columns: 'oO3-HkTd',
    trailingColumn: 'WUbkRksW',
    ' _key': 'mc-widgets/index'
};
export default css;
